import React from 'react'
import CreateResourcesForm from '../../features/Resources/CreateResourcesForm'

const CreateResources = () => {
  return (
    <div>
      <CreateResourcesForm />
    </div>
  )
}

export default CreateResources    
